// src/features/user/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

// Define the initial state of the user slice
const initialState = {
  user: null, //Stores the user information (null if no user is logged in).
  status: 'idle', // 'idle', 'loading', 'succeeded', 'failed'
  error: null, //Holds any error message if the login fails.
};

// Create a slice for user management
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginRequest(state) { //Set the status to 'loading' when a login request is initiated
      state.status = 'loading';
    },
    loginSuccess(state, action) {//Set the user state to the payload and mark the status as 'succeeded' when login is successful.
      state.user = action.payload;
      state.status = 'succeeded';
    },
    loginFailure(state, action) { //Store the error and set the status to 'failed' when login fails.
      state.error = action.payload;
      state.status = 'failed';
    },
    logout(state) { //Clears the user data and sets the status back to 'idle'.
      state.user = null;
      state.status = 'idle';
    },
  },
});

// Export actions for dispatching
export const { loginRequest, loginSuccess, loginFailure, logout } = userSlice.actions;

// Export the reducer to be used in the store
export default userSlice.reducer;
